export default __webpack_public_path__ + "static/media/partyparrot.e7f15aac.gif";